var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('longdo-map',{attrs:{"location":_vm.mapCenter,"zoom":15,"lastView":false}},_vm._l((_vm.markers),function(item,i){return _c('longdo-map-marker',{key:i,attrs:{"location":item.location,"title":item.title,"detail":item.detail}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }